// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"188":"component---src-pages-landing-tsx","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","768":"component---src-pages-app-tsx"}[chunkId] + "-" + {"188":"aa11da8dd784332328e7","245":"21b04eba1cc907625ad9","453":"82349a1b236b5e4d1c79","768":"b529f73050083bdb1e9a"}[chunkId] + ".js";
};